var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogIn = function SvgLogIn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M19.273 2.047a2.68 2.68 0 0 1 2.678 2.678V19.27a2.68 2.68 0 0 1-2.678 2.678h-4.156a.6.6 0 0 1 0-1.199h4.156a1.48 1.48 0 0 0 1.478-1.479V4.725a1.48 1.48 0 0 0-1.478-1.479h-4.156a.6.6 0 0 1 0-1.2zm-9.775 4.33a.6.6 0 0 1 .848 0l5.195 5.195a.6.6 0 0 1 .103.144.6.6 0 0 1 .074.281c0 .102-.03.196-.074.28a.6.6 0 0 1-.103.144l-5.195 5.195a.6.6 0 1 1-.848-.848l4.169-4.171H2.649a.6.6 0 1 1 0-1.2h11.02L9.498 7.227a.6.6 0 0 1 0-.848"
  })));
};
export default SvgLogIn;